export default __webpack_public_path__ + "static/media/img-ovato.5bb872d9.png";